const cleanUp = {
  removeBackslash(string) {
    return string.replace(/\\"/g, "\"");
  },
  replaceNewlineWithParagraph(string) {
    return string.replace(/(\n)+/g, "</p><p>");
  },
};

export default cleanUp;



// WEBPACK FOOTER //
// ./assets/pois/utils/cleanUp.js